import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  locales: ["en", "de-CH"],
  defaultLocale: "en",
  localePrefix: "as-needed",
  localeCookie: false,
  // Explicit URLs keep canonical pages stable regardless of Accept-Language.
  localeDetection: false,
});
